// Yearly Wrapped is a seasonal feature (like Spotify Wrapped): it only opens
// for a short window around the turn of the year, mid-December to mid-January.
// Outside that window the entry points are hidden and the story page shows a
// "come back in December" state. The public share card (/share/wrapped/:year)
// is deliberately NOT gated — a link someone shared in December keeps working
// year-round.
//
// This helper is duplicated in packages/api/src/lib/wrapped-season.ts (Wrapped
// is web-only, no @atlas/shared home yet — keep the two in sync).

const SEASON_START_MONTH = 11; // December (0-indexed)
const SEASON_START_DAY = 15;
const SEASON_END_MONTH = 0; // January
const SEASON_END_DAY = 15;

/** True from 15 December through 15 January (inclusive). */
export function isWrappedSeasonOpen(now: Date = new Date()): boolean {
  const month = now.getMonth();
  const day = now.getDate();
  if (month === SEASON_START_MONTH && day >= SEASON_START_DAY) return true;
  if (month === SEASON_END_MONTH && day <= SEASON_END_DAY) return true;
  return false;
}

/**
 * The year Wrapped should feature during the open window: the year that is
 * ending. In December that's the current year; in January it's the year that
 * just finished (getFullYear() has already rolled over, so the January half of
 * the window still reviews the previous year rather than the near-empty new one).
 */
export function featuredWrappedYear(now: Date = new Date()): number {
  const year = now.getFullYear();
  return now.getMonth() === SEASON_END_MONTH ? year - 1 : year;
}
